import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, mergeProps as _mergeProps, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "app-sidebar-header"
}
const _hoisted_2 = {
  key: 1,
  class: "app-sidebar-footer"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_p_divider = _resolveComponent("p-divider")!
  const _component_p_scrollpanel = _resolveComponent("p-scrollpanel")!
  const _component_p_sidebar = _resolveComponent("p-sidebar")!

  return (_openBlock(), _createBlock(_component_p_sidebar, _mergeProps({
    "show-close-icon": true,
    position: "right"
  }, _ctx.$attrs, { class: "app-sidebar" }), {
    default: _withCtx(() => [
      (_ctx.$slots.header)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _renderSlot(_ctx.$slots, "header"),
            _createVNode(_component_p_divider, { class: "p-mb-1 p-mt-0" })
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_p_scrollpanel, { class: "app-sidebar-content" }, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }),
      (_ctx.$slots.footer)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_component_p_divider, { class: "p-mt-1 p-mb-0" }),
            _renderSlot(_ctx.$slots, "footer")
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 3
  }, 16))
}